import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroIconDirective } from '../services/hero-icon.directive';

@NgModule({
    declarations: [HeroIconDirective],
    imports: [
        CommonModule
    ],
    exports: [HeroIconDirective]
})
export class SharedModule { }
